import type { DRCardDetails } from '../api/getMyGames';
import { getJerseyAvatarUrl } from './jerseyAvatar';
import { generateMLBHeadshotUrl } from './mlbHeadshot';
import type { TeamAssetFolderId } from './teamAssetFolder';

/**
 * Player image for cards: jerseys (league IP off) or headshots from blob (league IP on).
 *
 * The jersey path is resolved per card sport, so an NFL tile shows the same
 * position-cut jersey the Daily Reveal game renders instead of an MLB one.
 */
export function resolveMlbStylePlayerImage(
  card: DRCardDetails | null | undefined,
  teamCode: string,
  leagueIp: boolean,
  contestFolder: TeamAssetFolderId | null = null
): string {
  const sport = card?.sport ?? null;
  const jerseyUrl = () => getJerseyAvatarUrl(teamCode, sport, card?.position, contestFolder);

  if (!leagueIp) return jerseyUrl();
  if (!card) return '';
  if (card.photoUrl) return card.photoUrl;
  if (sport?.toUpperCase() === 'MLB' && card.firstName && card.lastName && teamCode) {
    return generateMLBHeadshotUrl(teamCode, card.firstName, card.lastName);
  }
  return jerseyUrl();
}

/** Hit outcome icons — served from lobby public/ (same paths as daily-reveal). */
export function hitOutcomeIconUrl(isPositive: boolean): string {
  return isPositive ? '/shapes/correct.svg' : '/shapes/incorrect.svg';
}
